// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1FPLU","errors":"Errors_errors__2GOeC"};